import { z } from 'zod';
function isValidTimeZone(value) {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}
/** IANA time zone name, e.g. Asia/Beirut. */
export const timezoneSchema = z
    .string()
    .min(1)
    .max(64)
    .refine(isValidTimeZone, 'Unknown time zone');
//# sourceMappingURL=timezone.js.map